import http from './http'
import { getToken } from './auth'

const authed = () => ({ headers: { 'Authorization': 'Bearer ' + getToken() } })

// ── Public (no login) — used by the customer self-entry page ────────────────
export async function getIntakeInfo(token) {
    const { data } = await http.get(`public/intake/${encodeURIComponent(token)}`)
    return data
}

export async function submitIntake(token, payload) {
    const { data } = await http.post(`public/intake/${encodeURIComponent(token)}`, payload)
    return data
}

// Private single-use enquiry link (app/c/link/<token>) — same payloads.
export async function getIntakeLinkInfo(token) {
    const { data } = await http.get(`public/intake/link/${encodeURIComponent(token)}`)
    return data
}

export async function submitIntakeViaLink(token, payload) {
    const { data } = await http.post(`public/intake/link/${encodeURIComponent(token)}`, payload)
    return data
}

// ── Office ───────────────────────────────────────────────────────────────────
export async function getIntakeLink() {
    const { data } = await http.get('Companies/self/intake-link', authed())
    return data
}

export async function regenerateIntakeLink() {
    const { data } = await http.post('Companies/self/intake-link/regenerate', {}, authed())
    return data
}

export async function getClientIntakes(status = 'PENDING') {
    const { data } = await http.get('client-intakes', { ...authed(), params: { status } })
    return data
}

export async function getPendingIntakeCount() {
    const { data } = await http.get('client-intakes/pending-count', authed())
    return data
}

export async function approveClientIntake({ id, mergeIntoClientId }) {
    const { data } = await http.post(`client-intakes/${id}/approve`, mergeIntoClientId ? { mergeIntoClientId } : {}, authed())
    return data
}

export async function rejectClientIntake(id) {
    const { data } = await http.post(`client-intakes/${id}/reject`, {}, authed())
    return data
}

export async function deleteClientIntake(id) {
    const { data } = await http.delete(`client-intakes/${id}`, authed())
    return data
}

// ── Office: private single-use enquiry links ─────────────────────────────────
export async function createPrivateIntakeLink({ label } = {}) {
    const { data } = await http.post('client-intakes/links', label ? { label } : {}, authed())
    return data
}

export async function getPrivateIntakeLinks() {
    const { data } = await http.get('client-intakes/links', authed())
    return data
}

export async function revokePrivateIntakeLink(id) {
    const { data } = await http.post(`client-intakes/links/${id}/revoke`, {}, authed())
    return data
}
